import { render, staticRenderFns } from "./ll2.vue?vue&type=template&id=05a93552&"
import script from "./ll2.vue?vue&type=script&lang=js&"
export * from "./ll2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports